import React, { Component } from "react";
import { connect } from "react-redux";
import server from "../../../api/server";
import Dashboard from "../Dashboard";
import ModuleHeader from "../elements/ModuleHeader";
import SectionHeader from "../elements/SectionHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faSignOutAlt, faSync, faSpinner, faChevronDown, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";

export class Servers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      servers: [],
      loading: false,
      hasMore: true,
      loadingMore: false,
      searchTerm: "",
      filteredServers: [],
      leaveByIdInput: "",
      leavingById: false,
      showLeaveByIdForm: false,
    };
  }

  componentDidMount() {
    this.getServers();
  }

  getServers = async (reset = true) => {
    this.setState({ loading: true });

    const response = await server.post("/dashboard/servers", {
      token: this.props.token,
      bot_id: this.props.bot.id,
    });

    if (response.data !== false) {
      const servers = response.data;
      this.setState({
        servers,
        filteredServers: servers,
        loading: false,
        hasMore: response.data.length > 190,  // if we get more than 190 servers, there might be more
        searchTerm: "", // Reset search term when refreshing
      });
    } else {
      this.setState({ loading: false, hasMore: false });
    }
  };

  loadMoreServers = async () => {
    if (!this.state.hasMore || this.state.loadingMore) return;

    this.setState({ loadingMore: true });

    // Get the ID of the last server to use as the 'after' parameter
    const lastServer = this.state.servers[this.state.servers.length - 1];

    const response = await server.post("/dashboard/servers", {
      token: this.props.token,
      bot_id: this.props.bot.id,
      after: lastServer.id,
    });

    if (response.data !== false && response.data.length > 0) {
      const updatedServers = [...this.state.servers, ...response.data];
      this.setState(prevState => ({
        servers: updatedServers,
        filteredServers: this.filterServers(updatedServers, prevState.searchTerm),
        loadingMore: false,
        hasMore: response.data.length > 190,  // if we get more than 190 servers, there might be more
      }));
    } else {
      this.setState({ loadingMore: false, hasMore: false });
    }
  };

  handleSearchChange = (e) => {
    const searchTerm = e.target.value;
    this.setState({
      searchTerm,
      filteredServers: this.filterServers(this.state.servers, searchTerm)
    });
  };

  filterServers = (servers, searchTerm) => {
    if (!searchTerm) return servers;

    const term = searchTerm.toLowerCase();
    return servers.filter(server =>
      server.name.toLowerCase().includes(term) ||
      server.id.toLowerCase().includes(term)
    );
  };

  clearSearch = () => {
    this.setState({
      searchTerm: "",
      filteredServers: this.state.servers
    });
  };

  toggleLeaveByIdForm = () => {
    this.setState(prevState => ({
      showLeaveByIdForm: !prevState.showLeaveByIdForm,
      leaveByIdInput: ""
    }));
  };

  handleLeaveByIdInputChange = (e) => {
    this.setState({ leaveByIdInput: e.target.value });
  };

  leaveServerById = async (e) => {
    e.preventDefault();
    const { leaveByIdInput } = this.state;

    if (!leaveByIdInput) return;

    this.setState({ leavingById: true });

    try {
      const response = await server.post("/dashboard/leaveserver", {
        token: this.props.token,
        bot_id: this.props.bot.id,
        id: leaveByIdInput,
      });

      if (response.data) {
        // Remove the server from the list if it exists
        this.setState(prevState => {
          const updatedServers = prevState.servers.filter(server => server.id !== leaveByIdInput);
          return {
            servers: updatedServers,
            filteredServers: this.filterServers(updatedServers, prevState.searchTerm),
            leavingById: false,
            leaveByIdInput: "",
            showLeaveByIdForm: false
          };
        });
      } else {
        this.setState({ leavingById: false });
      }
    } catch (error) {
      this.setState({ leavingById: false });
    }
  };

  renderServers = () => {
    var servers = [];

    this.state.filteredServers.forEach((ser, index) => {
      var disabled = false;
      var leaveServer = async () => {
        disabled = true;
        const response = await server.post("/dashboard/leaveserver", {
          token: this.props.token,
          bot_id: this.props.bot.id,
          id: ser.id,
        });

        if (response.data) {
          this.setState(prevState => {
            const updatedServers = prevState.servers.filter(s => s.id !== ser.id);
            return {
              servers: updatedServers,
              filteredServers: this.filterServers(updatedServers, prevState.searchTerm)
            };
          });
        }
      };

      servers.push(
        <div className="col-lg-6 col-md-12" style={{ padding: "12px" }} key={ser.id}>
          <div className="bg-[#1C1C1C] rounded-md shadow-md overflow-hidden hover:shadow-lg transition-all duration-200 border border-[#2A2A2A]">
            <div className="flex items-center p-4">
              <img
                src={
                  ser.icon != null
                    ? `https://cdn.discordapp.com/icons/${ser.id}/${ser.icon}.webp`
                    : process.env.PUBLIC_URL + "/images/icons/discord.png"
                }
                alt={ser.name}
                className="w-12 h-12 rounded-full mr-4 object-cover"
              />
              <div className="flex-grow">
                <h3 className="text-[#FFFFFF] font-medium text-base truncate">{ser.name}</h3>
                <p className="text-[#9CA3AF] text-xs truncate">{ser.id}</p>
              </div>
              <button
                disabled={disabled}
                onClick={leaveServer}
                className="bg-[#1F2937] hover:bg-[#374151] text-[#FFFFFF] py-2 px-4 rounded-md transition-colors duration-200 flex items-center border border-[#374151] disabled:opacity-50 disabled:cursor-not-allowed hover:border-[#5865f2]"
              >
                <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                Leave Server
              </button>
            </div>
          </div>
        </div>
      );
    });

    return servers;
  };

  render() {
    const { loading, filteredServers, searchTerm, hasMore, loadingMore, showLeaveByIdForm, leavingById, leaveByIdInput } = this.state;
    const totalServers = this.state.servers.length;
    const displayCount = filteredServers.length;

    return (
      <Dashboard>
        <div className="mt-8">
          <ModuleHeader
            showDocs={false}
            showEnabled={false}
            icon="discord.png"
            title="Servers"
            description="The servers your bot is currently active in"
          ></ModuleHeader>

          <section>
            <div className="mb-4">
              <SectionHeader
                title={`Active Servers (${totalServers}${hasMore ? '+' : ''})`}
                pretitle="SERVERS"
              />
            </div>

            {loading ? (
              <div className="flex justify-center items-center py-20">
                <FontAwesomeIcon icon={faSpinner} spin className="text-[#FFFFFF] text-2xl" />
              </div>
            ) : this.state.servers.length > 0 ? (
              <div className="server-list">
                <div className="flex flex-col lg:flex-row justify-between items-stretch gap-4 mb-6">
                  <div className="relative flex-grow">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FontAwesomeIcon icon={faSearch} className="text-[#6B7280]" />
                    </div>
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={this.handleSearchChange}
                      placeholder="Search by name or ID..."
                      className="bg-[#121212] w-full h-[46px] pl-10 pr-10 border border-[#2A2A2A] rounded-md text-[#FFFFFF] placeholder-[#6B7280] focus:outline-none focus:border-[#5865f2]"
                    />
                    {searchTerm && (
                      <button
                        onClick={this.clearSearch}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-[#6B7280] hover:text-[#FFFFFF]"
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </button>
                    )}
                  </div>
                  <div className="flex gap-3">
                    <button
                      className="bg-[#121212] h-[46px] hover:bg-[#1A1A1A] text-[#FFFFFF] py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center border border-[#2A2A2A] hover:border-[#5865f2] whitespace-nowrap"
                      onClick={this.toggleLeaveByIdForm}
                    >
                      <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                      Leave by ID
                    </button>
                    <button
                      className="bg-[#121212] h-[46px] hover:bg-[#1A1A1A] text-[#FFFFFF] py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center border border-[#2A2A2A] hover:border-[#5865f2] whitespace-nowrap"
                      onClick={this.getServers}
                    >
                      <FontAwesomeIcon icon={faSync} className="mr-2" />
                      Refresh
                    </button>
                  </div>
                </div>

                {/* Leave by ID form */}
                {showLeaveByIdForm && (
                  <div className="mb-6 bg-[#131823] border border-[#222F46] rounded-md p-5">
                    <h3 className="text-[#FFFFFF] font-medium mb-3">Leave Server by ID</h3>
                    <form onSubmit={this.leaveServerById} className="flex flex-col sm:flex-row gap-3">
                      <input
                        type="text"
                        value={leaveByIdInput}
                        onChange={this.handleLeaveByIdInputChange}
                        placeholder="Enter server ID..."
                        className="bg-[#121212] flex-grow h-[46px] px-4 py-2 border border-[#2A2A2A] rounded-md text-[#FFFFFF] placeholder-[#6B7280] focus:outline-none focus:border-[#5865f2]"
                      />
                      <button
                        type="submit"
                        disabled={!leaveByIdInput || leavingById}
                        className="bg-[#121212] h-[46px] hover:bg-[#1A1A1A] text-[#FFFFFF] py-2 px-4 rounded-md transition-colors duration-200 flex items-center justify-center border border-[#2A2A2A] hover:border-[#5865f2] disabled:opacity-50 disabled:cursor-not-allowed min-w-[140px]"
                      >
                        {leavingById ? (
                          <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                        ) : (
                          <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />
                        )}
                        {leavingById ? "Leaving..." : "Leave Server"}
                      </button>
                    </form>
                  </div>
                )}

                {searchTerm && (
                  <div className="mb-4 text-[#9CA3AF] text-sm">
                    {displayCount} {displayCount === 1 ? 'server' : 'servers'} found
                  </div>
                )}

                {filteredServers.length > 0 ? (
                  <>
                    <div className="row">{this.renderServers()}</div>

                    {!searchTerm && hasMore && (
                      <div className="flex justify-center mt-8 mb-3">
                        <button
                          className="bg-[#121212] hover:bg-[#1A1A1A] text-[#FFFFFF] py-3 px-6 rounded-md transition-colors duration-200 flex items-center justify-center border border-[#2A2A2A] hover:border-[#5865f2] disabled:opacity-50 disabled:cursor-not-allowed"
                          onClick={this.loadMoreServers}
                          disabled={loadingMore}
                        >
                          {loadingMore ? (
                            <>
                              <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />
                              Loading...
                            </>
                          ) : (
                            <>
                              <FontAwesomeIcon icon={faChevronDown} className="mr-2" />
                              Load More Servers
                            </>
                          )}
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="bg-[#121212] rounded-md p-8 text-center border border-[#2A2A2A]">
                    <div className="text-[#9CA3AF] mb-4">
                      No servers found matching your search.
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="bg-[#121212] rounded-md p-8 text-center border border-[#2A2A2A]">
                <div className="flex flex-col items-center">
                  <div className="text-[#9CA3AF] mb-4 text-lg">
                    Please invite your bot to a server using the{" "}
                    <FontAwesomeIcon icon={faLink} /> Invite Link and then click
                    refresh
                  </div>
                  <button
                    className="bg-[#121212] hover:bg-[#1A1A1A] text-[#FFFFFF] py-2 px-4 rounded-md transition-colors duration-200 flex items-center border border-[#2A2A2A] hover:border-[#5865f2]"
                    onClick={this.getServers}
                  >
                    <FontAwesomeIcon icon={faSync} className="mr-2" />
                    Refresh Server List
                  </button>
                </div>
              </div>
            )}
          </section>
        </div>
      </Dashboard>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.data.bot.token,
  bot: state.data.bot,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Servers);
